import { MainMarket } from '~api/market/types';
import { ToggleGroupItem } from '~components/atoms/ToggleGroup';
import { Text } from '~components/atoms/Typography';
import { useMedia } from '~hooks';
import { useIsTextOverflowing } from '~hooks/useIsTextOverflowing';

export type ToggleType =
  | 'toggle'
  | 'bet'
  | 'market'
  | 'payment'
  | 'userProfileMobileTab'
  | 'lightMarket';

export const ToggleGroupItemComponent = ({
  type = 'market',
  market,
  marketSelected,
  sportId,
}: {
  type?: ToggleType;
  market: MainMarket;
  marketSelected: Record<number, number>;
  sportId: number;
}) => {
  const { isOverflowing, spanRef } = useIsTextOverflowing();
  const { isMobileOrTablet } = useMedia();

  const { name, shortName, id } = market;
  const showShortName =
    (isMobileOrTablet && shortName) || (isOverflowing && shortName);

  return (
    <ToggleGroupItem
      key={name}
      type={type}
      value={id}
      disabled={id === marketSelected[sportId]}
    >
      <Text ref={spanRef} as="span">
        {showShortName ? shortName : name}
      </Text>
    </ToggleGroupItem>
  );
};
